export default "__VITE_ASSET__BxIqg8Tb__"